import { useMemo } from "react";

const SYMBOLS = ["☉", "☽", "☿", "♀", "♂", "♃", "♄", "♅", "♆", "⊕"];

export default function AstroBackground({ count = 10 }) {
  const items = useMemo(() => Array.from({ length: count }, (_, i) => ({
    symbol: SYMBOLS[i % SYMBOLS.length],
    left: `${8 + ((i * 91) % 84)}%`,
    top: `${5 + ((i * 173) % 88)}%`,
    size: 12 + ((i * 37) % 14),
    opacity: 0.04 + ((i * 7) % 9) / 100,
    duration: 18 + ((i * 23) % 22),
    delay: -((i * 31) % 20),
  })), [count]);

  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", overflow: "hidden", pointerEvents: "none", zIndex: 0 }}
    >
      {items.map((item, i) => (
        <span
          key={i}
          style={{
            position: "absolute",
            left: item.left,
            top: item.top,
            fontSize: `${item.size}px`,
            color: "#B89047",
            opacity: item.opacity,
            animation: `astroFloat ${item.duration}s ${item.delay}s ease-in-out infinite`,
            display: "block",
            lineHeight: 1,
            fontFamily: "serif",
            userSelect: "none",
          }}
        >
          {item.symbol}
        </span>
      ))}
    </div>
  );
}
